import InvitationApi from './rest/InvitationApi';

export default new InvitationApi();
